import { gql } from "@apollo/client"

export const DeleteDeliveryMethod = gql`
mutation DeleteDeliveryMethod($deleteDeliveryMethodId: ID!) {
  deleteDeliveryMethod(id: $deleteDeliveryMethodId) {
    status
  }
}
`